// Client mirror of server/src/sim/roads.ts (keep in sync). The renderer derives the
// road lattice from these so what's drawn matches exactly where pets are allowed to walk.
export const AV = 3;
export const ST_START = 6, ST_STEP = 5;
export const WEST_ARTERIAL = -1;

export const isAvenue = (gy: number): boolean => (((gy % AV) + AV) % AV) === 0;
export const isStreet = (gx: number): boolean => gx === WEST_ARTERIAL || (gx >= ST_START && (gx - ST_START) % ST_STEP === 0);
export const isRoad = (gx: number, gy: number): boolean => isAvenue(gy) || isStreet(gx);
